/**
 * Builds the wallet widget container badge text from a count and localised label
 * strings. Shared across GiftCards, FNA and NUA wallet sections.
 *
 * @param count        - The number of items (awards / cards) to display
 * @param labels.defaultLabel         - Shown when count === 0 (e.g. "No Awards")
 * @param labels.availableSingularLabel - Template for count === 1 (e.g. "{0} Award")
 * @param labels.availablePluralLabel   - Template for count !== 1 (e.g. "{0} Awards")
 */
export const buildWalletBadgeText = (
  count: number,
  labels: {
    defaultLabel?: string;
    availableSingularLabel?: string;
    availablePluralLabel?: string;
  }
): string => {
  const token = String(count);
  const { defaultLabel, availableSingularLabel, availablePluralLabel } = labels;

  if (count === 0) {
    if (defaultLabel) return defaultLabel;
    if (availablePluralLabel) return availablePluralLabel.replace('{0}', token);
    return '';
  }
  if (count === 1) {
    if (availableSingularLabel) return availableSingularLabel.replace('{0}', token);
    if (availablePluralLabel) return availablePluralLabel.replace('{0}', token);
    return '';
  }
  return availablePluralLabel ? availablePluralLabel.replace('{0}', token) : '';
};
